import * as React from 'react';
import { IListFilterProps, User } from '../../../core';
import { FilterValue } from '../../api';
import { useDataLoader } from 'react-remote-data-hooks';
import api from '../../../api';
import { DebounceInput } from 'react-debounce-input';

interface IMultiSelectFilterProps<T = any> extends IListFilterProps<T> {
  loadData: (query: string) => Promise<any[]>;
  allowSearch?: boolean;
  value?: FilterValue[];
  key?: string;
  removeUnassigned?: boolean;
}

const MultiSelectFilterWithApiSearch: React.FunctionComponent<IMultiSelectFilterProps> = (
  props
) => {
  const { data, reload,  } = useDataLoader((query:string) => props.loadData(query || ''));

  const [search, setSearch] = React.useState('');

  React.useEffect(() => {
      reload(search);
  }, [search])

  React.useEffect(() => {
    if (data && !props.removeUnassigned) {
      data.unshift({ name: 'Unassigned', _id: null });
    }
  }, [data]);

  const list =  React.useMemo(() => 
    search
    ? data?.filter((us: User) => us.name?.match(new RegExp(search, 'si')))
    : data
  ,[data])


  const [selected, setSelected] = React.useState<FilterValue[]>(
    props.value || []
  );

  React.useEffect(() => {
    setSelected(props.value || []);
  }, [props.value]);

  const onAllSelected = (isSelected: boolean) => {
    const allValues = !isSelected
      ? []
      : list?.map((ff: User) => {
          return {
            label: ff.name,
            value: ff._id,
          };
        });

    setSelected(allValues);
  };

  const onSelect = (value: FilterValue, sel: boolean) => {
    if (sel) {
      setSelected([...(selected || []), value]);
    } else {
      setSelected(selected?.filter((val) => val.value !== value.value) || []);
    }
  };

  const onApply = () => {
    setSearch('');
    props.applyFilter?.(selected);
  };

  const onClose = () => {
    setSearch('');
    props.onClose?.();
  };

  return (
    <>
      <div className="pb-3">
        <div className="d-flex align-items-center justify-content-between bg-primary px-3 py-2 text-white">
          <h6 className="m-0 font-xs font-weight-semibold">{props.label}</h6>
          <span
            className="cursor-pointer d-inline-block text-center rounded-circle sub-dropdown-back ml-3"
            onClick={onClose}
          >
            <i className="icon-close font-xxs"></i>
          </span>
        </div>
        {props.allowSearch && (
          <div className="search">
            <div className="input-group border-bottom">
              {/* <input
                type="text"
                className="form-control border-0 pr-0"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            /> */}
              <DebounceInput
                  className="form-control border-0 pr-0"
                  minLength={1}
                  debounceTimeout={300}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search"
                  value={search}
                />
              <div className="input-group-append">
                <span className="form-control-search btn btn-link border-0 bg-transparent px-3 py-0" />
              </div>
            </div>
          </div>
        )}
        <ul className="list-unstyled p-2 m-0">
          {!!list?.length && (
            <li key="all-0" className="py-2 pb-3 border-bottom">
              <input
                type="checkbox"
                id={`all-${props.label}`}
                onChange={(e) => onAllSelected(e.target.checked)}
                checked={
                  !list.find(
                    (ff: User) => !selected.find((fff) => ff._id === fff.value)
                  )
                }
              />
              <label
                htmlFor={`all-${props.label}`}
                className="font-xs font-weight-semibold"
              >
                {props.label}
              </label>
            </li>
          )}

          {list?.map((option: User, index: number) => {
            const label = option.name;
            const value = option._id;

            return (
              <li key={index} className="py-2">
                <input
                  type="checkbox"
                  id={value || props.label}
                  onChange={(e) => onSelect({ label, value }, e.target.checked)}
                  checked={!!selected?.find((fv) => fv.value === value)}
                />
                <label
                  htmlFor={value || props.label}
                  className="font-xs font-weight-semibold"
                >
                  {label}
                </label>
              </li>
            );
          })}
        </ul>
        <div className="px-3 text-right">
          <button
            type="button"
            className="btn btn-primary py-2 px-4 font-weight-semibold"
            onClick={onApply}
          >
            <span className="px-2">Apply</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default MultiSelectFilterWithApiSearch;
